jQuery(document).ready(function($) {

  //Move primary task tabs to admin toolbar
  var $tabs = $('#primary-tasks li');
  var $toolbar = $('ul.toolbar-menu');
  if ($tabs && $toolbar) {
    $toolbar.append($tabs);
  }


});